import A from 'utils/metrics/analytic'

enum originShare {
  WEBINAR_FUTURE = 'webinar_future',
  WEBINAR_ACTIVE = 'webinar_active',
  WEBINAR_PAST = 'webinar_past',
  ARTICLE = 'article',
  VIDEO = 'video',
  PODCAST = 'podcast',
  CLINICALCASE = 'clinicalcase',
  CLINREC = 'clinrec',
}
// Нажать на "Поделиться"
const A_sm_shareOpen = (origin: originShare) => {
  A.setEvent('share_open', { origin })
}

// Нажать на Однокласники , вк и тд
const A_sm_clickShare = (type: string) => {
  A.setEvent('share_click', {
    share_type: type,
  })
}

// Пользователь нажал на кнопку "Мне нравится"

const A_sm_clickLike = (origin: originShare) => {
  A.setEvent('like_click_true', { origin })
}

export { A_sm_shareOpen, A_sm_clickLike, A_sm_clickShare, originShare }
